import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDxuQkFVMe3xDN_wimL0yKGdIJlLz2jIR8",
  authDomain: "huskdet-30854.firebaseapp.com",
  projectId: "huskdet-30854",
  storageBucket: "huskdet-30854.firebasestorage.app",
  messagingSenderId: "558837762131",
  appId: "1:558837762131:web:aa0f2b0a8f2e8c8e8f2e8c"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
